"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEEKDAY_NAME_MAPPING = exports.MONTH_NAME_MAPPING = void 0;
const types_1 = require("./types");
exports.MONTH_NAME_MAPPING = new Map([
    ["january", types_1.Month.January],
    ["february", types_1.Month.February],
    ["march", types_1.Month.March],
    ["april", types_1.Month.April],
    ["may", types_1.Month.May],
    ["june", types_1.Month.June],
    ["july", types_1.Month.July],
    ["august", types_1.Month.August],
    ["september", types_1.Month.September],
    ["october", types_1.Month.October],
    ["november", types_1.Month.November],
    ["december", types_1.Month.December],
]);
exports.WEEKDAY_NAME_MAPPING = new Map([
    ["sunday", types_1.Weekday.Sunday],
    ["monday", types_1.Weekday.Monday],
    ["tuesday", types_1.Weekday.Tuesday],
    ["wednesday", types_1.Weekday.Wednesday],
    ["thursday", types_1.Weekday.Thursday],
    ["friday", types_1.Weekday.Friday],
    ["saturday", types_1.Weekday.Saturday],
]);
